export * from './domain-contact-advanced';
export * from './domain-contact-data';
export * from './domain-contact-general';
export * from './domain-contact-identity-card';
export * from './domain-contact-trendmark';
